<template>    
  <Toast />
  <div class="row">
    <div class="col">
      <h2 class="titre">Ajout Jeux</h2>
    </div>
  </div>
  <ModifierChamps ref="modifierChamps" :isModifier="false"/>
  <ButtonBar @fermer="fermer" @ajouter="ajouter" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Ajouter/ButtonBarJeux.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsJeux.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  components: {
    ButtonBar,
    ModifierChamps,
    DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
    };
  },
	computed: {
		...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      listeJeux: 'jeux/listeJeux',
		})
  },
  beforeMount() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('jeux/resetJeuxStoredAction', {
      cleDossier: this.$route.params.cleDossier,
      siteDossier: this.$route.params.siteDossier,
    });
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Ajouter jeux");
  },
  methods: {
    ajouter() {
      this.isSauvegardeEnCours = true;
      this.$store.commit('jeux/UPDATE_JEUX', this.$refs.modifierChamps.getNewJeuxLocal());
      this.$store.dispatch('jeux/ajouterJeuxAction', {
        jeux: this.listeJeux,
      }).then((res) =>{
        this.$root.$refs.messagesComp.messagesList = res.data.messages
        if (res?.data?.messages.length == 0) {
          this.$toast.add({
            severity:'success',
            summary: 'Ajouter',
            detail:'Le jeux a été ajouté.',
            life: 6000
          });
          this.fermer();
        }
        else{
          this.$store.commit('jeux/LISTE_JEUX',[]);
        }
        this.isSauvegardeEnCours = false;
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },        
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.$refs.modifierChamps.getJeuxLocal(), this.$refs.modifierChamps.getAncienJeuxLocal());
  },    
};
</script>
